import { render } from "./qzf-td.vue?vue&type=template&id=a19930fc&scoped=true"
import script from "./qzf-td.vue?vue&type=script&lang=js"
export * from "./qzf-td.vue?vue&type=script&lang=js"

import "./qzf-td.vue?vue&type=style&index=0&id=a19930fc&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19930fc"]])

export default __exports__